import React from 'react'

const Videos = () => {
  return (
    <div>
      videos page
    </div>
  )
}

export default Videos
